import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {RouterLink} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {VisionProviderSummary} from '../../models/vision-provider-management';
import {VisionProviderManagementViewService} from '../../services/vision-provider-management';

@Component({
    selector: 'app-provider-list',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './provider-list.component.html',
    styleUrl: './provider-list.component.css',
})
export class ProviderListComponent implements OnInit {
    providers: VisionProviderSummary[] = [];
    loading = false;

    constructor(
        private viewService: VisionProviderManagementViewService,
        private toastr: ToastrService,
    ) {
    }

    ngOnInit(): void {
        this.loadProviders();
    }

    loadProviders(): void {
        this.loading = true;
        this.viewService.discoverProviders().subscribe({
            next: (providers) => {
                this.providers = providers;
                this.loading = false;
            },
            error: () => {
                this.providers = [];
                this.loading = false;
                this.toastr.error('Unable to load vision providers.');
            },
        });
    }

    statusClass(status: VisionProviderSummary['health_status']): string {
        return `provider-status-badge provider-status-badge--${status}`;
    }

    formatTimestamp(value: string | null): string {
        return this.viewService.formatTimestamp(value);
    }
}
